module.exports = __webpack_public_path__ + "static/img/music.13c6e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/music.png
// module id = 21
// module chunks = 0